import React, { useRef } from "react";
import { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import { Line } from "react-chartjs-2";
import { useEffect } from "react";
import { fetchApi } from "../../helper/api";
import { SensorProps } from "../../helper/functionSensor";
// import { height } from "@mui/system";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);

export const LineChart = ({ sensor, date }) => {
  const [dataGraph, setDataGraph] = useState(null);
  const [dataResponse, setDataResponse] = useState(null);
  const [show, setShow] = useState(false);
  let divRef = useRef({});
  const options = (type) => {
    return {
      responsive: true,
      scales: {
        y: {
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value) {
              if (sensor != null) {
                // console.log("Sensor", sensor);
                return (
                  value.toFixed(2) +
                  SensorProps[sensor.label.split(" ")[0]].satuan
                );
              } else {
                return value;
              }
            },
          },
        },
      },
      elements: {
        line: {
          tension: 0.5,
        },
      },
      interaction: {
        mode: "index",
        intersect: false,
      },
      stacked: false,
      plugins: {
        title: {
          display: type === "none" ? false : true,
          text: `Grafik ${type}`,
          padding: { bottom: 20, top: 0 },
          font: { size: 14 },
        },
        legend: {
          display: type === "none" ? false : true,
          position: "bottom",
          labels: {
            // boxWidth: 25,
            usePointStyle: true,
          },
          align: "center",
        },
        tooltip: {
          //   callbacks: {
          //     title: (p) => {
          //       let labelTooltip;
          //       if (time === "day") {
          //         labelTooltip = "Time";
          //       } else if (time === "month") {
          //         labelTooltip = "Date";
          //       } else if (time === "year") {
          //         labelTooltip = "Month: ";
          //       }
          //       return `${labelTooltip}: ${p[0].label}`;
          //     },
          //     label: (p) => {
          //       let unit;
          //       if (sensor === "voltage") {
          //         unit = "V";
          //       } else if (sensor === "current") {
          //         unit = "A";
          //       } else if (sensor === "temperature") {
          //         unit = "°C";
          //       }
          //       return `${p.dataset.label}: ${Number(p.raw).toFixed(2)} ${unit}`;
          //     },
          //   },
          mode: "index",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        zoom: {
          zoom: {
            wheel: {
              enabled: sensor || date ? true : false, // SET SCROOL ZOOM TO TRUE
            },
            mode: "x",
            speed: 5,
          },
          pan: {
            enabled: sensor || date ? true : false,
            mode: "xy",
            speed: 10,
          },
        },
      },
      animation: {
        duration: 0,
      },
      maintainAspectRatio: false,
    };
  };
  let defaultData = {
    name: "",
    labels: [],
    datasets: [
      {
        label: "Average",
        data: [],
        borderColor: "rgb(44, 255, 37)",
        backgroundColor: "rgba(44, 255, 37, 0.5)",
      },
      {
        label: "Max Data",
        data: [],
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Min Data",
        data: [],
        borderColor: "rgb(255, 192, 0)",
        backgroundColor: "rgb(255, 192, 0,0.5)",
      },
    ],
  };
  useEffect(() => {
    if (date && sensor) {
      (async () => {
        const url = `api/Data/dataInterval?idSensor=${sensor.value}&date=${date}`;
        // console.log(url);
        // console.log(sensor);
        const req = await fetchApi(url, "get", true);
        const res = await req.json();
        if (req.status === 200) {
          // console.log(res);
          const { data } = res;
          setDataResponse(data);
          let tempLabels = [];
          let tempData = [];
          if (data.length > 0) {
            let countParameterSensor = data[0].datas.length;
            // console.log(countParameterSensor);
            for (let i = 0; i < countParameterSensor; i++) {
              tempData.push({
                name: data[0].datas[i].type,
                labels: [],
                datasets: [
                  {
                    label: "Average",
                    data: [],
                    borderColor: "rgb(44, 255, 37)",
                    backgroundColor: "rgba(44, 255, 37, 0.5)",
                  },
                  {
                    label: "Max Data",
                    data: [],
                    borderColor: "rgb(255, 99, 132)",
                    backgroundColor: "rgba(255, 99, 132, 0.5)",
                  },
                  {
                    label: "Min Data",
                    data: [],
                    borderColor: "rgb(255, 192, 0)",
                    backgroundColor: "rgb(255, 192, 0,0.5)",
                  },
                ],
              });
            }
            // console.log("TEMP AWAL", tempData);
            // console.log("DATA: ", data);
            data.map((item) => {
              tempLabels.push(item.label);
              item.datas.map((dataEach, index) => {
                tempData[
                  tempData.findIndex((find) => find.name === dataEach.type)
                ].datasets[0].data.push(dataEach.average_data);
                // tempData[index].name = data.type;
                tempData[
                  tempData.findIndex((find) => find.name === dataEach.type)
                ].datasets[1].data.push(dataEach.max_data);
                tempData[
                  tempData.findIndex((find) => find.name === dataEach.type)
                ].datasets[2].data.push(dataEach.min_data);
              });
            });
          } else {
            tempData.push({
              name: "none",
              labels: [],
              datasets: [
                {
                  label: "Average",
                  data: [],
                  borderColor: "rgb(44, 255, 37)",
                  backgroundColor: "rgba(44, 255, 37, 0.5)",
                },
                {
                  label: "Max Data",
                  data: [],
                  borderColor: "rgb(255, 99, 132)",
                  backgroundColor: "rgba(255, 99, 132, 0.5)",
                },
                {
                  label: "Min Data",
                  data: [],
                  borderColor: "rgb(255, 192, 0)",
                  backgroundColor: "rgb(255, 192, 0,0.5)",
                },
              ],
            });
            alert(
              `Perhatian!\n\Data grafik hari ini di tanggal ${date}, kosong`
            );
          }
          for (let i = 0; i < tempData.length; i++) {
            tempData[i].labels.push(...tempLabels);
          }
          // console.log("TEMP AKHIR", tempData);
          setDataGraph(tempData);
        }
      })();
    }
  }, [sensor, date]);

  useEffect(() => {
    if (dataGraph) {
      setShow(true);
    }
  }, [dataGraph]);

  const ResetButton = ({ type }) => {
    return (
      <button
        onClick={() => {
          divRef.current[type].resetZoom();
        }}
        type="button"
        style={{
          position: "absolute",
          top: "-10%",
          right: "-1.5%",
          borderRadius: "5px",
          backgroundColor: "#2196f3",
          border: "0.5px solid lightgray",
          color: "white",
          padding: "0.5em 1.2em",
          marginRight: "1em",
          fontSize: "0.8rem",
          boxShadow:
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
        }}
      >
        RESET
      </button>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "fit-content",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "30px",
          width: "99%",
        }}
      >
        {!sensor || !date ? (
          <div style={{ height: "350px", padding: "0px 14px" }}>
            <Line
              ref={(ref) => (divRef.current["none"] = ref)}
              options={options("none")}
              data={defaultData}
            />
          </div>
        ) : show ? (
          dataGraph.map((item) => {
            return (
              <div
                style={{
                  position: "relative",
                  height: "350px",
                  // padding: "0px 14px",
                }}
              >
                <Line
                  ref={(ref) => (divRef.current[item.name] = ref)}
                  options={options(item.name)}
                  data={item}
                />
                <ResetButton type={item.name} />
              </div>
            );
          })
        ) : null}
      </div>
    </div>
  );
};
